import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Assessment } = await import('@containers/Assessment/index');
    return {
        Component: Assessment,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
